import { getRandomIntInclusive } from './get-random-int-inclusive';

export const getRandomWidth = () =>
  `${getRandomIntInclusive(80, 90) + getRandomIntInclusive(0, 9)}%`;
